const usePDFViewerHook = ({ analytics }) => window.console.log('usePDFViewerHook');
export { usePDFViewerHook };
//# sourceMappingURL=pdf-viewer.hook.js.map